/* eslint-disable no-useless-escape */
export const MAX_ITEMS_PER_REQUEST = 999;
export const MAX_ITEMS_PER_IMAGE_REQUEST = 30;
export const NOTE_MAX_LENGTH = 10000;
export const QUANTITY_MAX_LENGTH = 10;
export const MRN_MAX_LENGTH = 32;
export const PKID_MAX_LENGTH = 4;
export const PRICE_PATTERN = /^(\d+(?:[\.]\d{1,6})?)$/;
export const REQUEST_NAME_PATTERN = /[a-zA-Z0-9]*((-|,|.|:|\s)*[a-zA-Z0-9])/;
export const INTEGER_PATTERN = /[0-9]*/;
export const INTEGER_PATTERN_EXCEPT_ZERO_VALUE = /^[1-9][0-9]*$/;
export const IMAGE_DENOM_PATTERN = /^[0-9 .,-]*$/;
export const MRN_PATTERN = /^[a-zA-Z0-9-]*$/;
export const MAX_PO_TOTAL = 999999999.9999; // <9>.<4>
export const MAX_PO_SUB_TOTAL = 9999999.99; // <7>.<2>
export const MAX_POP_PROD_COST_TOTAL = 9999999999.9999; // <10>.<4>
export const MAX_BIF_COST_TOTAL = 99999999.99; // <8>.<2>
export const MAX_REBILL_TOTAL = 9999999999.9999; // <10>.<4>
export const MAX_BIF_REBILL_TOTAL = 99999999.9999; // <8>.<4>
export const IH_MAX_PACKAGES = 99;
export const IH_MAX_COMPONENTS_PER_ITEM = 10;
export const IH_LABELS_QUANTITY_MULTIPLIER = 5000;
export const THIRD_MAX_RANGES_PER_ITEM = 99;
export interface PaymentType {
  code: string;
  name: string;
}
